import React from 'react';
import PlaywrightRegister from '../component/PlaywrightRegister';

function PlaywrightTraining() {
  return (
    <div id="myContactus">
      <PlaywrightRegister />
    </div>
  );
}

export default PlaywrightTraining;
